import { Navigate, Route, Routes } from "react-router-dom";
import SiteShell from "./SiteShell";
import AboutPage from "./pages/AboutPage";
import AudiencePage from "./pages/AudiencePage";
import ConnectPage from "./pages/ConnectPage";
import FeaturesPage from "./pages/FeaturesPage";
import HomePage from "./pages/HomePage";
import NichePage from "./pages/NichePage";
import PricingPage from "./pages/PricingPage";
import { nicheRouteSegment, PATHS } from "./nav";
import { NICHE_ORDER, NICHE_PAGES } from "./nicheContent";

export default function VioletClarityLanding() {
  return (
    <SiteShell>
      <Routes>
        <Route index element={<HomePage />} />
        <Route path="vozmozhnosti" element={<FeaturesPage />} />
        <Route path="tarify" element={<PricingPage />} />
        <Route path="dlya-kogo" element={<AudiencePage />} />
        <Route path="podklyuchenie" element={<ConnectPage />} />
        <Route path="o-kompanii" element={<AboutPage />} />
        {NICHE_ORDER.map((id) => (
          <Route
            key={id}
            path={nicheRouteSegment(NICHE_PAGES[id].path)}
            element={<NichePage nicheId={id} />}
          />
        ))}
        <Route path="*" element={<Navigate to={PATHS.home} replace />} />
      </Routes>
    </SiteShell>
  );
}
